"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Arrow = exports.Container = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const svg_components_1 = require("../../../assets/svg-components");
exports.Container = styled_components_1.default.div `
  display: ${props => (props.showElement ? 'inline-flex' : 'none')};
  justify-content: center;
  align-items: center;
  position: fixed;
  bottom: ${props => props.theme.spacing.m6}px;
  right: ${props => props.theme.spacing.s4}px;
  width: ${props => props.theme.spacing.l1}px;
  height: ${props => props.theme.spacing.l1}px;
  background: rgba(225, 225, 225, 0.5);
  border-radius: 50%;
  cursor: pointer;
  animation: ${props => props.theme.animations.easeInOut}
    ${props => (props.isOnScreen ? props.theme.themeKeyframes.fadeIn : props.theme.themeKeyframes.fadeOut)} forwards;

  :hover {
    background: rgba(225, 225, 225, 1);
  }
`;
exports.Arrow = (0, styled_components_1.default)(svg_components_1.ArrowIcon) `
  transform: rotate(180deg);
`;
exports.default = {
    Container: exports.Container,
    Arrow: exports.Arrow
};
